import { format, addDays } from 'date-fns';
export function formatDuration(duration) {
  const [hours, minutes] = duration.split(':');
  const days = Math.floor(hours / 24);
  const hoursRounded = hours % 24;
  let str = '';
  if (days > 0) {
    str += `${days}d `;
  }
  if (hoursRounded > 0 || minutes > 0) {
    str += `${hoursRounded}h `;
    if (minutes > 0) {
      str += `${minutes}m `;
    }
  }
  return str.trim();
}

export function formatDuration2(duration) {
  const [hours, minutes] = duration.split(':');
  const days = Math.floor(hours / 24);
  const hoursRounded = hours % 24;
  const durationParts = [];
  if (days > 0) {
    durationParts.push({ unit: 'd', value: days });
  }
  if (hoursRounded > 0 || minutes > 0) {
    durationParts.push({ unit: 'h', value: hoursRounded });
    if (minutes > 0) {
      durationParts.push({ unit: 'm', value: minutes });
    }
  }
  return durationParts;
}

export const setDateAsTommorrow = (url) => {
  return url
    .replace(/departDate=\d{1,2}-\d{1,2}-\d{4}/, `departDate=${format(addDays(new Date(), 1), 'dd-MM-yyyy')}`)
    .replace(/startDate=\d{1,2}-\d{1,2}-\d{4}/, `startDate=${format(addDays(new Date(), 1), 'dd-MM-yyyy')}`)
    .replace(/departure=\d{4}\d{1,2}\d{1,2}/, `departure=${format(addDays(new Date(), 1), 'yyyyMMdd')}`)
    .replace(/date=\d{4}\d{1,2}\d{1,2}/, `date=${format(addDays(new Date(), 1), 'yyyyMMdd')}`);
};
